export const SET_MODALS = 'SET_MODALS';

export const setModals = (value, closeOther) => {
  return (dispatch, getState) => {
    if (Array.isArray(value)) {
      return dispatch({ type: SET_MODALS, modals: value });
    }
    if (closeOther) {
      return dispatch({ type: SET_MODALS, modals: [value] });
    }
    const { modals } = getState().commonStore;
    return dispatch({ type: SET_MODALS, modals: [...modals, value] });
  };
};
